<template>
	<div class="pages" v-loading="listLoading">
		<div v-for='(item,index) in templateData.TemplateContent.Controls' :key='index'>
			<Digit v-if='item.Property.Control=="Number"' :data-val='item'></Digit>
			<Contact v-if='item.Property.Control=="Condition"' :data-val="item"></Contact>
			<Dates v-if='item.Property.Control=="Date"' :data-val="item"></Dates>
			<Version v-if='item.Property.Control=="Text"' @child-event='getTextVal' :data-val="item"></Version>
			<Money v-if='item.Property.Control=="Money"' :data-val="item"></Money>
			<Tips v-if='item.Property.Control=="Tips"' :data-val="item"></Tips>
			<File v-if='item.Property.Control=="File"' :data-val="item"></File>
			<Table v-if='item.Property.Control=="Table"' @child-event='tableOperation' :data-val='item' :template-data='templateData'></Table>
			<Selector v-if='item.Property.Control=="Selector"' @child-event='getSelectorVal' :data-val='item'></Selector>
			<Textarea v-if='item.Property.Control=="Textarea"' :data-val='item'></Textarea>
			<Choose v-if='item.Property.Control=="Contact"' @child-event='clickChoose' :data-val='item'></Choose>
		</div>


		<Button class="submit-process" v-on:click='submit' v-bind:loading="formLoading" size="large" type="primary"> 确认
		</Button>
		<Button class="submit-process" v-on:click='refuse' v-bind:loading="formLoading" size="large" type="primary"> 驳回
		</Button>
	</div>
</template>

<script>
	/**
	 * Version 为Text文本组件
	 */
	import Digit from '../components/Number.vue'
	import Contact from '../components/Contact.vue';
	import Dates from '../components/Date.vue';
	import Version from '../components/Text.vue';
	import Money from '../components/Money.vue';
	import Tips from '../components/Tips.vue';
	import File from '../components/File.vue';
	import Table from '../components/Table.vue';
	import Selector from '../components/Selector.vue';
	import Textarea from '../components/Textarea.vue';
	import Choose from '../components/Choose.vue';
	import wx from 'weixin-js-sdk'
	import stringUtils from "../assets/js/stringUtil.js";
	import {
		initWxConfig
	} from '../api/jssdk.js';
	import {
		getTemplateInfo,
		submitProcess,
		getFlowTemplate,
		sendMessage,
		AllowApplyForVerify,
		GetPendingProcessById
	} from '@/api/approval'
	import {
		getRelation,
    getUserInfo
	} from '@/api/employee'
  import { getOptionValForDataVal } from '../utils/componentUtils'

	var isSubmit = false;

	var template = {
		TemplateContent: {
			Controls: []
		}
	};
	const sendMessagetTemplate = {
	  title: null,
	  url: null,
	  toUser: [],
	  desc: null,
	  template: null,
	};
	export default {
		components: {
			Contact,
			Dates,
			Version,
			Money,
			Tips,
			File,
			Table,
			Digit,
			Selector,
			Textarea,
			Choose
		},
		data() {
			return {
				templateData: template,
				relationList: null,
				logInfo: null,
				templateId: "",
				spNo: null,
				formLoading: false,
				listLoading: false,
				flowId:null,
				applyTemplateData:null,
				applicant:null,
				sendMessageData: Object.assign({},sendMessagetTemplate)
			}
		},
		created() {
			initWxConfig(this);
			this.logInfo = this.getLoginUserInfo();
			this.templateId = this.$route.query.templateId;
			this.spNo = this.$route.query.spNo;
			this.applicant = this.$route.query.empNo;
			this.flowId = this.$route.query.flowId;
			this.getTemplate();
			stringUtils.setAddIsShow(true);
		},
		methods: { //方法
			clickChoose(dataVal, name) {
				window.wx.invoke("selectEnterpriseContact", {
					"fromDepartmentId": 0, // 必填，表示打开的通讯录从指定的部门开始展示，-1表示自己所在部门开始, 0表示从最上层开始
					"mode": "single", // 必填，选择模式，single表示单选，multi表示多选
					"type": ["department"], // 必填，选择限制类型，指定department、user中的一个或者多个
					"selectedDepartmentIds": [], // 非必填，已选部门ID列表。用于多次选人时可重入，single模式下请勿填入多个id
					"selectedUserIds": [] // 非必填，已选用户ID列表。用于多次选人时可重入，single模式下请勿填入多个id
				}, function(res) {
					if (res.err_msg == "selectEnterpriseContact:ok") {
						if (typeof res.result == 'string') {
							res.result = JSON.parse(res.result) //由于目前各个终端尚未完全兼容，需要开发者额外判断result类型以保证在各个终端的兼容性
						}
						var depart = res.result.departmentList[0]; // 已选的部门列表
						dataVal.Values=[];
						dataVal.Values.push([depart.id,depart.name]);
						dataVal.Value = depart.name;
					}
				})
			},
			getFlowTemplateInfo: async function() {
				if(this.flowId==null||this.flowId==undefined||this.flowId.length<=0){
						return;
				}
				await getFlowTemplate(this.flowId).then(response => {
					this.applyTemplateData = response.Body;
				});
			},
			getTemplate: async function() {
				await GetPendingProcessById(this.flowId).then(response =>{
					if(response.Body==null){
						this.Message({
							message: '该流程已经处理完成',
							type: 'success',
							duration: 3 * 1000
						});
						setTimeout(() => {
							this.$router.push("/Pricing");
						}, 1000)
						return;
					}
				})
				this.listLoading = true;
				let jobLevel = this.logInfo.JobLevel;
        const preEmp = await getUserInfo(this.applicant)
				await getTemplateInfo(this.templateId).then(async response => {
					var controls = response.Body;
					await this.getEmployeeRelation();
					controls.TemplateContent.Controls.forEach((item) => {
						// var departs = this.logInfo.fullName.split("/");
						if (item.Property.Title[0].Text == "人员") {
							item.Disable = true;
						}
						if (item.Property.Title[0].Text == "工号") {
							item.Disable = true;
						}
						if (item.Property.Title[0].Text == "申请时间") {
							item.Disable = true;
						}
						if (item.Property.Title[0].Text == "选择所在部门") {
							item.Disable = true;
						}
						if (item.Property.Title[0].Text == "项目名称") {
							item.Disable = true;
						}
						if (item.Property.Title[0].Text == "申请事宜") {
							item.Disable = true;
						}
						if (item.Property.Title[0].Text == "申请说明") {
							item.Disable = true;
						}
						if (item.Property.Title[0].Text == "选择营运部门总经理审批") {
							item.Disable = true;
						}
						if (item.Property.Title[0].Text == "附件") {
							item.Disable = true;
						}
						if (item.Property.Title[0].Text == "营运部门总经理") {
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "是否总经理审批") {
							item.Property.Require = 1;
						}
						if (item.Property.Title[0].Text === "是否抄送给财务") {
              item.IsShow = false;
              const options = item.Config.Selector.Options
              const option = options.filter(e => e.Value[0].Text === "否")
              item.Value = option[0].Key
            }
					});
					this.templateData = this.assignControl(controls, this.logInfo);
					this.templateData = await this.assignControlBySpNo(controls, null,this.flowId);
					//   是否抄送财务      是否显示约定是否返还         是否显示在实际操作中约定返还
					let Status = false,showAgreedReturn = false,showActualOperation = false;
          this.templateData.TemplateContent.Controls.forEach(item => {
            const controlName = item.Property.Title[0].Text
            if (controlName === "申请事宜") {
              const options = item.Config.Selector.Options
              const option = options.filter(e => e.Key === item.Value)[0]
              // 如果选择的是销售上数或者策划上数就显示是否抄送给财务选择框
              if (option.Value[0].Text === "销售上数" || option.Value[0].Text === "策划上数") {
                Status = true
              }
              if (option.Value[0].Text === "策划上数") {
                showAgreedReturn = true
              }
            }else if(controlName === "合同中是否有约定返还"){
              item.IsShow = showAgreedReturn
              item.Disable = true
              showActualOperation = getOptionValForDataVal(item.Value,item) === "是"
            }else if(controlName === "实际操作中是否有返还"){
              item.IsShow = showActualOperation
              item.Disable = true
            }
            if (controlName === "是否抄送给财务") {
              item.IsShow = Status
            }
            if (controlName === "人员"){
              if (item.Values === null || item.Values.length === 0){
                const { EmpNo,EmpName } = preEmp.Body.EmployeeInfo
                item.Values = []
                item.Values.push([EmpNo,EmpName])
                item.Value = EmpName
              }
            }
          })
					this.listLoading = false;
				});
			},
			getEmployeeRelation: async function() {
				await getRelation(this.logInfo.EmpNo).then(response => {
					this.relationList = response.Body[0].Nodes;
				});
			},
			getTextVal() {},
			getSelectorVal(val, name) {},
			tableOperation(val, type, datas) {
				if(type=='compute'){
					return;
				}
				this.tableoperation(val, type, datas, this);
			},
			refuse(){
				this.sendMessageData.template=this.templateData;
				this.sendMessageData.title="二级市场特殊情况报备签批";
				this.sendMessageData.toUser=[];
				
				var control=this.templateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "人员"})[0]
				this.sendMessageData.toUser.push(control.Values[0][0])
				this.sendMessageData.desc="驳回人员："+this.logInfo.EmpName;
				this.sendMessageData.url=document.location.hostname+"/specialSituationReport?templateId=3TmBHXKPMBbiB4AjU5APW8Wroni1dVap2bi1KXaP&flowId="+this.flowId;
				//提交
				sendMessage(this.templateId, this.logInfo.EmpNo, this.spNo, this.sendMessageData,2,"",this.flowId).then(response => {
					this.Message({
						message: '驳回成功',
						type: 'success',
						duration: 3 * 1000
					});
					setTimeout(() => {
						this.$router.push("/index");
					}, 3000)
				}).finally(() => {
				});
			},
			submit() {
				//数据校验
				if (!this.submitValidate(this.templateData.TemplateContent.Controls)) {
					return;
				}
				if (isSubmit) {
					this.Message({
						message: '已提交',
						type: 'warning',
						duration: 1000
					});
					return;
				}
				var SummaryList = [];
				var info={SummaryInfo:[]}
				info.SummaryInfo=[];
				var control1=this.templateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "选择所在部门"})[0]
				var control1Text=control1.Config.Selector.Options.filter(t=>{return t.Key==control1.Value})[0].Value[0].Text;
				var info={SummaryInfo:[]}
				info.SummaryInfo=[];
				info.SummaryInfo.push({"Text":"选择所在部门："+control1Text,"Lang":"zh_CN"});
				SummaryList.push(info);
				
				var control2=this.templateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "项目名称"})[0]
				var info={SummaryInfo:[]}
				info.SummaryInfo=[];
				info.SummaryInfo.push({"Text":"项目名称："+control2.Value,"Lang":"zh_CN"});
			    SummaryList.push(info);
				
				var control3=this.templateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "申请事宜"})[0]
				var control3Text=control3.Config.Selector.Options.filter(t=>{return t.Key==control3.Value})[0].Value[0].Text;
				var info={SummaryInfo:[]}
				info.SummaryInfo=[];
				info.SummaryInfo.push({"Text":"申请事宜："+control3Text,"Lang":"zh_CN"});
				SummaryList.push(info);
				
				
			    this.templateData.SummaryList=SummaryList
				isSubmit = true;
				this.listLoading = true;
				//提交
				submitProcess(this.templateId, this.applicant, this.spNo, this.templateData, this.flowId).then(response => {
					this.Message({
						message: '申请成功',
						type: 'success',
						duration: 3 * 1000
					});
					setTimeout(() => {
						this.$router.push("/index");
					}, 3000)
				}).finally(() => {
					isSubmit = false;
					this.listLoading = false;
				});
			}
		}

	}
</script>

<style scoped lang="less">
	.pages {
		padding-bottom: 14px;
	}
</style>
